import {
	NahledyudajuPppPppStavEnum,
	type NahledyudajuPppPppZakladniUdajeDto,
} from '@gov-nx/api';
import type { PPPLocaleReturnType } from '../usePPPLocale';
import { toDateReadable } from '@gov-nx/utils/common';

export type ResolveReasonResult = {
	isVisible: boolean;
	text: string;
};

export const resolveReason = (
	zakladniUdaje: NahledyudajuPppPppZakladniUdajeDto | undefined,
	fallback: string
): ResolveReasonResult => {
	if (zakladniUdaje?.stav === NahledyudajuPppPppStavEnum.ZAMITNUTO) {
		return {
			isVisible: true,
			text: zakladniUdaje.duvodZamitnuti ?? fallback,
		};
	}
	return { isVisible: false, text: '' };
};

export const isTerminateButtonVisible = (
	stav: NahledyudajuPppPppStavEnum | undefined
): boolean => stav === NahledyudajuPppPppStavEnum.SCHVALENO;

export const isComplainButtonVisible = (
	stav: NahledyudajuPppPppStavEnum | undefined
): boolean => stav === NahledyudajuPppPppStavEnum.SCHVALENO;

export const resolveChipLabel = (
	zakladniUdaje: NahledyudajuPppPppZakladniUdajeDto | undefined,
	t: PPPLocaleReturnType['t']
): string => {
	const statusesWithDate = [
		NahledyudajuPppPppStavEnum.ZAMITNUTO,
		NahledyudajuPppPppStavEnum.UKONCENO,
	];

	if (!zakladniUdaje?.stav) {
		return '';
	}

	const label = t(`detail.zadost.chip.stav.${zakladniUdaje.stav}`);

	if (statusesWithDate.includes(zakladniUdaje.stav)) {
		const date = zakladniUdaje.datumPosledniZmeny
			? toDateReadable(zakladniUdaje.datumPosledniZmeny)
			: null;
		return [label, date].filter(Boolean).join(' ');
	}

	return label;
};
